import dayjs from 'dayjs';

import { mergeDeep } from '../utils';

/**
 * Return true if a date is before the current date
 * @param {Date} day
 */

const isPastDate = (day) => {
  return dayjs(dayjs(day).format('MM/DD/YYYY')).isBefore(dayjs().format('MM/DD/YYYY'));
};

/**
 * Determine if a date is the current date
 * @param {Date} day
 */
const isCurrentDay = (day) => {
  return dayjs(dayjs(day).format('MM/DD/YYYY')).isSame(dayjs().format('MM/DD/YYYY'));
};

const isOutsideDay = (day, currentMonth) => {
  return (
    dayjs(dayjs(day).format('MM/DD/YYYY')).month() !==
    dayjs(dayjs(currentMonth).format('MM/DD/YYYY')).month()
  );
};

/**
 * Determine if a date is the same date
 * @param {Date} day
 */
const isSameDate = (day1, day2) => {
  return dayjs(dayjs(day1).format('MM/DD/YYYY')).isSame(dayjs(day2).format('MM/DD/YYYY'));
};

const modifiers = (props) => {
  const {
    currentDayStyles,
    pastDayStyles,
    outsideDayStyles,
    blackoutDayStyles,
    withinDateRangeStyles,
    selectedStartDateStyles,
    selectedEndDateStyles,
    isOutside,
    lowestPriceStyles,
    noPriceAvailableStyles,
    noPriceAvailableAndCurrentDayStyle,
    selectedDateStyles,
    selectedDateNoPriceAvailableStyles,
    currentDayAndLowestPriceStyles,
    currentDayLoadingStyles,
    currentDaySelectedLoadingStyles,
    emptyStyles,
    emptyStylesAndCurrentDayStyle,
    withinDateRangeBlackoutDayStyles,
    withinDateRangeisOutsideStyles,
    applyLoadingStyle = false,
    startDateLoadingStyles,
    endDateLoadingStyles,
    day,
    isLowest,
    data,
    disregardedBehavior,
    isDisregarded,
    selected = false,
    isBlackoutDay,
    isEmptyCard = false,
    isInDateRange = false,
    selectedStartDate = false,
    selectedDay = false,
    selectedEndDate = false,
    loadingStatus = false
  } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, ...obj } = props;
  const modifiersObj = {};

  // noPriceAvailable
  if (data && data.dataType && data.dataType === 'EMPTY_FROM_API') {
    Object.assign(modifiersObj, noPriceAvailableStyles);
  }

  // pastDay
  if (isPastDate(day) || (isDisregarded && disregardedBehavior === 'past-date')) {
    Object.assign(modifiersObj, pastDayStyles);
  }
  // currentDay
  if (data && isCurrentDay(day)) {
    Object.assign(modifiersObj, currentDayStyles);
  }
  // lowestPrice
  if (isLowest && !isPastDate(day)) {
    Object.assign(modifiersObj, lowestPriceStyles);
  }
  // currentDayAndLowestPrice
  if (isCurrentDay(day) && isLowest && !isPastDate(day)) {
    Object.assign(modifiersObj, currentDayAndLowestPriceStyles);
  }
  // outside
  if (isOutside) {
    Object.assign(modifiersObj, outsideDayStyles);
  }
  if (isBlackoutDay) {
    Object.assign(modifiersObj, blackoutDayStyles);
  }
  //empty
  if (data && data.dataType && data.dataType === 'EMPTY') {
    Object.assign(modifiersObj, emptyStyles);
  }
  //current day and empty
  if (data && data.dataType && data.dataType === 'EMPTY' && isCurrentDay(day)) {
    Object.assign(modifiersObj, emptyStylesAndCurrentDayStyle);
  }

  // noPriceAvailable and current day
  if (data && data.dataType && data.dataType === 'EMPTY_FROM_API' && isCurrentDay(day)) {
    Object.assign(modifiersObj, noPriceAvailableAndCurrentDayStyle);
  }

  // selected
  if (selected && !isPastDate(day)) {
    if (data && data.dataType && data.dataType === 'EMPTY_FROM_API') {
      Object.assign(modifiersObj, selectedDateNoPriceAvailableStyles);
    } else {
      Object.assign(modifiersObj, selectedDateStyles);
    }
  }

  //empty
  if (isEmptyCard && !isOutside) {
    Object.assign(modifiersObj, pastDayStyles);
  }

  //isInDateRange
  if (isInDateRange && !loadingStatus) {
    if (isOutside) {
      Object.assign(modifiersObj, withinDateRangeisOutsideStyles);
    } else if (isBlackoutDay) {
      Object.assign(modifiersObj, withinDateRangeBlackoutDayStyles);
    } else {
      Object.assign(modifiersObj, withinDateRangeStyles);
    }
  }

  if (selectedStartDate && !isOutside) {
    Object.assign(modifiersObj, selectedStartDateStyles);
  }

  if (selectedEndDate && !isOutside) {
    Object.assign(modifiersObj, selectedEndDateStyles);
  }

  if (selectedDay && !isPastDate(day) && !isDisregarded && !isOutside) {
    if (data && data.dataType && data.dataType === 'EMPTY_FROM_API') {
      Object.assign(modifiersObj, selectedDateNoPriceAvailableStyles);
    } else {
      Object.assign(modifiersObj, selectedDateStyles);
    }
  }
  if (data && isCurrentDay(day) && loadingStatus) {
    if (selectedStartDate || selectedEndDate) {
      Object.assign(modifiersObj, currentDaySelectedLoadingStyles);
    } else {
      Object.assign(modifiersObj, currentDayLoadingStyles);
    }
  }
  if (selectedStartDate && applyLoadingStyle) {
    Object.assign(modifiersObj, startDateLoadingStyles);
  }
  if (selectedEndDate && applyLoadingStyle) {
    Object.assign(modifiersObj, endDateLoadingStyles);
  }

  const target = mergeDeep({}, obj);
  const result = mergeDeep(target, modifiersObj);
  return result;
};

export { modifiers, isPastDate, isCurrentDay, isSameDate, isOutsideDay };
